import { getToken, clearAuth } from './auth.js';
export { getToken } from './auth.js';

async function request(method, path, body, opts = {}) {
  const headers = { ...(opts.headers || {}) };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  let payload = body;
  if (body && !(body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
    payload = JSON.stringify(body);
  }
  // Belt-and-suspenders: never let the UI hang past 30s waiting on the API.
  const ctl = new AbortController();
  const t = setTimeout(() => ctl.abort(), 30000);
  let res;
  try {
    res = await fetch(path, { method, headers, body: payload, signal: ctl.signal });
  } finally {
    clearTimeout(t);
  }
  if (res.status === 401) {
    clearAuth();
    if (!path.endsWith('/api/auth/me') && !window.location.pathname.startsWith('/login') && !window.location.pathname.startsWith('/r/')) {
      window.location.href = '/login';
    }
  }
  const ct = res.headers.get('content-type') || '';
  const data = ct.includes('application/json') ? await res.json() : await res.text();
  if (!res.ok) {
    const err = new Error((data && data.error) || res.statusText);
    err.status = res.status;
    err.body = data;
    throw err;
  }
  return data;
}

export const api = {
  get:   (p, o)    => request('GET',   p, null, o),
  post:  (p, b, o) => request('POST',  p, b, o),
  put:   (p, b, o) => request('PUT',   p, b, o),
  patch: (p, b, o) => request('PATCH', p, b, o),
  del:   (p, o)    => request('DELETE', p, null, o),
};
